// MUI Imports
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

function ConfirmDialog(props) {
    const { open, onClose, onConfirm, sx, color, title } = props;
    return (
        <Dialog open={open} onClose={onClose} sx={sx}>
            {title && <DialogTitle>{title}</DialogTitle>}
            <DialogContent>
                {props.children}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color={color} variant='outlined'>Cancel</Button>
                <Button onClick={onConfirm} color={color} variant='contained'>Confirm</Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmDialog;